import { colors } from "../../assets/colors"

export const container = {
    backgroundColor: colors.white,
    flexGrow: 1,
    height: "100vh",
    overflow: "auto",
    padding: 6
}

export const repositoryContent = {
    marginTop: 6,
    marginBottom: 5
}

export const formPipeline = {
    mt: 8,
    width: 600,
    display: 'flex',
    flexDirection: 'row',
    gap: 2
}

export const select = {
    borderRadius: '8px',
    backgroundColor: colors.white,
    width: '100%'
}

export const button = {
    width: 200,
    height: '50px',
    marginTop: 3,
    borderRadius: '8px'
}